import { useContext, useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, DomainElement, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import Layout from './Layout';
import { addUserSpecificDomains, getinstituteList } from '../../../library/Service/domainService';
import { SUBCATEGORY_QUESTION_MAP } from './markerSubCategoryMap';
import useManagementDashboard from '../../management/dashboard/useManagementDashboard';
import SmartContextPage from '../../../library/Core/SmartContextPage';

const InternalAdminReport = () => {
    
    const { globalState } = useContext(GlobalContext);
    const { getCampuses } = useManagementDashboard();
    const [campuses, setCampuses] = useState([]);
   
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const MARKER_CATEGORY_TO_SUBCATEGORY: Record<string, string[]> = {
    ABILITY: ['workProfile', 'demographics', 'positionStrength'],
    WILLINGNESS: ['affinity', 'influence'],
    INVOLVEMENT: ['digitalCampaign', 'general']
    };

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

    useEffect(() => {
        setCampuses(getCampuses());
        console.log('campuses', campuses);
        // const domain = new Map([...globalState.domain]);
        const userStatusCodes = domain.get('USER_STATUS_CODE');
        if (userStatusCodes) {
            const filtereduserstatusCode = userStatusCodes.filter((status) => status.code !== 'PENDING_EMAIL_VERIFICATION');
            domain.set('USER_STATUS_CODE', filtereduserstatusCode);
        }
        // if (instituteList) {
        //     domain.set('MANAGEMENT_INSTITUTE_DOMAIN', instituteList);
        // }
        
       const timer = setTimeout(() => {
            dispatch({
                type: 'DATA_INIT',
                payload: { formConfig, data, domain, internal, routeInfo },
            });
        }, 0);
        return () => clearTimeout(timer);
    }, []);

        useEffect(() => {
        const selectedSubCategories =
            state?.data?.searchCriteria?.markerSubCategory;

            if (!selectedSubCategories?.length) {
            domain.set('MARKER_QUESTION', []);
            return;
        }

        const questionDomainArray: DomainElement[] =
        (selectedSubCategories ?? []).flatMap(
            (subCat: string, subIndex: number) =>
            (SUBCATEGORY_QUESTION_MAP[subCat] || []).map(
                (option, index) => ({
                categoryCode: 'MARKER_QUESTION',
                code: option.code,              
                value: option.value,            
                parentCode: subCat
                })
            )
        );
        console.log("questionDomainArray",questionDomainArray)
        domain.set(
            'MARKER_QUESTION',
            questionDomainArray ||  []
        );

        dispatch({
            type: 'SET_DOMAIN',
            payload: { key: 'MARKER_QUESTION', value: questionDomainArray },
        });
       
    }, [state?.data?.searchCriteria?.markerSubCategory]);

   
    return (
        <SmartContextPage state={state} dispatch={dispatch}>
            <Layout />
        </SmartContextPage>
    );
};

export default InternalAdminReport;
